import { calculatePercentComplete } from './calculate-percent-complete';
export function extractNonSequentialTaskProgressInfo(nodeMap, taskProgress) {
    var completed = Object.keys(taskProgress).filter(function (id) { return taskProgress[id].completed != null; });
    // try to sort the completed array by completion date
    completed.sort(function (a, b) {
        var _a, _b;
        return extractUnixTime(((_a = taskProgress[a].completed) === null || _a === void 0 ? void 0 : _a.at) || null) -
            extractUnixTime(((_b = taskProgress[b].completed) === null || _b === void 0 ? void 0 : _b.at) || null);
    });
    var activeNodes = new Set();
    var endingNodes = new Set();
    for (var _i = 0, _a = Object.keys(nodeMap); _i < _a.length; _i++) {
        var nodeId = _a[_i];
        // skip initial node
        if (nodeMap[nodeId].type === 'start')
            continue;
        // skip completed nodes
        if (completed.indexOf(nodeId) === -1) {
            activeNodes.add(nodeId);
            if (nodeMap[nodeId].type === 'ending') {
                endingNodes.add(nodeId);
            }
        }
    }
    return {
        isSequenced: false,
        completedPath: completed,
        farthestEndingDistance: 0,
        percentComplete: calculatePercentComplete(completed.length, activeNodes.size - endingNodes.size),
        activeNodes: activeNodes,
        nodesAhead: new Set(),
        canBeCompleted: true,
        farthestEndingPath: [],
    };
}
function extractUnixTime(date) {
    var time = Date.parse(date || '');
    return isNaN(time) ? Infinity : time;
}
